import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function NotFoundPage() {
  return (
    <Card className="max-w-xl">
      <CardHeader>
        <CardTitle>404</CardTitle>
      </CardHeader>
      <CardContent className="text-muted-foreground">
        Diese Seite existiert nicht.
      </CardContent>
    </Card>
  );
}


